import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fe9f0be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { colspan: "3" }
const _hoisted_2 = {
  key: 1,
  class: "snNumber"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.props.type ? 'inventory-sf-type' : 'inventory-sf'])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (process, processIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: _ctx.index,
        class: _normalizeClass([
        _ctx.props.type ? 'inventory-table-type' : 'inventory-table',
        process.value,
      ])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, _toDisplayString(process.label) + "工序库存", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(process.data, (modelList, modelListKey) => {
            return (_openBlock(), _createElementBlock("div", {
              key: modelListKey,
              class: "model-table"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelList, (model, modelIndex) => {
                return (_openBlock(), _createElementBlock("table", {
                  border: "1",
                  class: "plan-table",
                  key: modelIndex
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_1, _toDisplayString(model.label), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.data, (type, typeIndex) => {
                      return (_openBlock(), _createElementBlock("th", { key: typeIndex }, _toDisplayString(type.label) + " " + _toDisplayString(type.data.length), 1))
                    }), 128))
                  ]),
                  _createElementVNode("tr", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.data, (type, typeIndex) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: typeIndex,
                        class: "series-number"
                      }, [
                        (type.data.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(type.data, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "snNumber"
                              }, _toDisplayString(item.outputSnNumber || item.snNumber), 1))
                            }), 128))
                          : (_openBlock(), _createElementBlock("div", _hoisted_2))
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ], 2))
    }), 128))
  ], 2))
}